(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const loadMoreButton = document.querySelector('.js-load-more');
  if (!loadMoreButton) return;

  loadMoreButton.addEventListener('click', function() {
    const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
    const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
    const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

    if (currentPage < totalPages) {
      loadMoreButton.disabled = true;
      loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
      loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

      fetch(nextPageUrl)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const html = parser.parseFromString(data, 'text/html');
          const newItems = html.querySelectorAll('.blog-list__item');
          const blogList = document.querySelector('.blog-list__list');
          newItems.forEach(item => blogList.appendChild(item));

          // Update button state
          const newButton = html.querySelector('.js-load-more');
          if (newButton) {
            loadMoreButton.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', newButton.getAttribute('data-current-page'));
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            if (parseInt(newButton.getAttribute('data-current-page')) >= totalPages) {
              loadMoreButton.style.display = 'none';
            }
          } else {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch(error => {
          console.error('Error loading more articles:', error);
          loadMoreButton.disabled = false;
          loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
          loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
        });
    } else {
      loadMoreButton.style.display = 'none';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Load more products scripts
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      
      loadMoreButton.addEventListener('click', function() {
      const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

      if (currentPage < totalPages) {
        loadMoreButton.disabled = true;
        loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
        loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = html.querySelectorAll('.collection-grid__item');

            const gridList = document.querySelector('.collection-grid__grid-list');
            newItems.forEach(item => {
              gridList.appendChild(item);
            });

            
            const newCurrentPage = html.querySelector('.js-load-more').getAttribute('data-current-page');
            loadMoreButton.setAttribute('data-next-url', html.querySelector('.js-load-more').getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', newCurrentPage);

            if (parseInt(newCurrentPage) >= totalPages) {
              loadMoreButton.style.display = 'none';
            } else {
              loadMoreButton.disabled = false;
              loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
              loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          });
      } else {
        loadMoreButton.style.display = 'none';
      }
    });
  });
  }

  // Filter navigation scripts
  const navToggleButtons = document.querySelectorAll('.js-collection-grid-nav-toggle');
  if (navToggleButtons.length > 0) {
    navToggleButtons.forEach(navToggleButton => {

      // Event listener function to close the nav toggle when clicking outside of it
      const closeNavToggleFunction = function(event) {
        const navList = document.querySelector('.js-collection-grid-nav');
        const navToggle = document.querySelector('.js-collection-grid-nav-toggle');
        if (navList && navToggle && !navToggle.contains(event.target) && !navList.contains(event.target)) {
          navList.classList.remove('expanded');
          navToggle.setAttribute('aria-expanded', false);
        }
      };

      // Add event listener to toggle button for mobile
      navToggleButton.addEventListener('click', function() {
        const navList = navToggleButton.nextElementSibling;
        navList.classList.toggle('expanded');
        const isExpanded = navList.classList.contains('expanded');
        navToggleButton.setAttribute('aria-expanded', isExpanded);
        if (isExpanded) {
          document.addEventListener('click', closeNavToggleFunction, true);
        } else {
          document.removeEventListener('click', closeNavToggleFunction, true);
        }
      });

      // Add event listener to close button on menu for mobile
      const navToggleClose = document.querySelector('.js-collection-grid-nav-toggle-close');
      if (navToggleClose) {
        navToggleClose.addEventListener('click', function() {
          const navList = document.querySelector('.js-collection-grid-nav');
          navList.classList.remove('expanded');
          navToggleButton.setAttribute('aria-expanded', false);
        });
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maker-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Load more products scripts
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      
      loadMoreButton.addEventListener('click', function() {
      const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

      if (currentPage < totalPages) {
        loadMoreButton.disabled = true;
        loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
        loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = html.querySelectorAll('.maker-products__item');

            const gridList = document.querySelector('.maker-products__list');
            newItems.forEach(item => {
              gridList.appendChild(item);
            });

            
            const newCurrentPage = html.querySelector('.js-load-more').getAttribute('data-current-page');
            loadMoreButton.setAttribute('data-next-url', html.querySelector('.js-load-more').getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', newCurrentPage);

            if (parseInt(newCurrentPage) >= totalPages) {
              loadMoreButton.style.display = 'none';
            } else {
              loadMoreButton.disabled = false;
              loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
              loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          });
      } else {
        loadMoreButton.style.display = 'none';
      }
    });
  });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Load more results script
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      
      loadMoreButton.addEventListener('click', function() {
      const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

      if (currentPage < totalPages) {
        loadMoreButton.disabled = true;
        loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
        loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = html.querySelectorAll('.search-results__item');

            const gridList = document.querySelector('.search-results__list');
            newItems.forEach(item => {
              gridList.appendChild(item);
            });

            
            const newCurrentPage = html.querySelector('.js-load-more').getAttribute('data-current-page');
            loadMoreButton.setAttribute('data-next-url', html.querySelector('.js-load-more').getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', newCurrentPage);

            if (parseInt(newCurrentPage) >= totalPages) {
              loadMoreButton.style.display = 'none';
            } else {
              loadMoreButton.disabled = false;
              loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
              loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          });
      } else {
        loadMoreButton.style.display = 'none';
      }
    });
  });
  }
});

  } catch(e) { console.error(e); }
})();
})();
